import { unit } from 'mathjs';
import definition from '@client/config/definition';
import { SPORT_TYPE } from './constant';

class BasisTransform {
  constructor(next) {
    this.next = null;
  }

  setNext(next) {
    this.next = next;
  }
}

class DefaultTransform extends BasisTransform {
  exec(val, sportType, summary, systemUnit) {
    const unit2transform = systemUnit === definition.METRIC_UNITS ? 'km' : 'mi';
    return val.toNumber(unit2transform);
  }
}

class TransformForOpenWater extends BasisTransform {
  exec(val, sportType, summary, systemUnit) {
    let unit2transform = '';
    if (sportType === SPORT_TYPE.OPEN_WATER) {
      const formattedDistance = unit(summary.distance, 'cm');
      if (systemUnit === definition.METRIC_UNITS) {
        unit2transform = formattedDistance.toNumber('m') > 9999 ? 'km' : 'm';
      } else if (systemUnit === definition.IMPERIAL_UNITS) {
        unit2transform = formattedDistance.toNumber('yard') > 9999 ? 'mi' : 'yard';
      }
      return val.toNumber(unit2transform);
    } else {
      return this.next.exec(...arguments);
    }
  }
}

class TransformForRowing extends BasisTransform {
  exec(val, sportType, summary, systemUnit) {
    // 赛艇和划船机不需要考虑系统单位，按米或千米转换
    if ([SPORT_TYPE.ROWING, SPORT_TYPE.ROWING_MACHINE].includes(sportType)) {
      const unit2transform = unit(summary.distance, 'cm').toNumber('m') > 9999 ? 'km' : 'm';

      return val.toNumber(unit2transform);
    } else {
      return this.next.exec(...arguments);
    }
  }
}

class TransformForClimb extends BasisTransform {
  exec(val, sportType, summary, systemUnit) {
    if (sportType === SPORT_TYPE.CLIMB) {
      const unit2transform = systemUnit === definition.METRIC_UNITS ? 'm' : 'ft';

      return val.toNumber(unit2transform);
    } else {
      return this.next.exec(...arguments);
    }
  }
}

export default class TransformDistance {
  static transform(val, sportType, summary, systemUnit) {
    const forClimb = new TransformForClimb();
    const forOpenWater = new TransformForOpenWater();
    const forRowing = new TransformForRowing();
    const defaultTransform = new DefaultTransform();

    forClimb.setNext(forOpenWater);
    forOpenWater.setNext(forRowing);
    forRowing.setNext(defaultTransform);

    return forClimb.exec(val, sportType, summary, systemUnit);
  }
}
